var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2247 8.90666V9.33017C15.2247 11.706 15.2247 14.0811 15.2247 16.4569C15.2247 17.1453 15.037 17.3333 14.3482 17.3333C11.3419 17.3333 8.3363 17.3333 5.33003 17.3333C4.64321 17.3333 4.45621 17.1447 4.45553 16.4549C4.45553 14.0791 4.45553 11.704 4.45553 9.32817V8.90666C4.25036 9.01906 4.08555 9.1047 3.92478 9.19837C3.47004 9.46331 3.23661 9.41916 2.93995 8.97892C2.37893 8.14596 1.82799 7.3063 1.27234 6.46932C1.1183 6.23716 0.956851 6.00835 0.810877 5.7715C0.551217 5.34933 0.646067 4.94924 1.06583 4.68162C2.65002 3.67136 4.24296 2.67381 5.81505 1.64548C6.22539 1.37719 6.64582 1.28821 7.10258 1.34776C7.30574 0.750964 7.4248 0.666664 8.03965 0.666664C9.23973 0.666664 10.4398 0.666664 11.6399 0.666664C12.2574 0.666664 12.3738 0.748957 12.5776 1.35177C13.2571 1.18116 13.7569 1.58125 14.2836 1.91845C15.7151 2.83639 17.1506 3.74696 18.5835 4.66222C19.0503 4.96062 19.1196 5.30317 18.8175 5.75545C18.0998 6.83261 17.3827 7.91112 16.6683 8.9903C16.3918 9.40778 16.1496 9.46532 15.7158 9.20506C15.5731 9.11942 15.4319 9.03178 15.2254 8.90533L15.2247 8.90666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenIcon);
export default __webpack_public_path__ + "static/media/men-icon.42a24d3a4a4ff93ae8dcc92798b5498b.svg";
export { ForwardRef as ReactComponent };